import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback, useState, useEffect } from 'react';

export const useRecaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);

    // Monitor when executeRecaptcha becomes available
    useEffect(() => {
        if (executeRecaptcha) {
            setIsRecaptchaReady(true);
        } else {
            setIsRecaptchaReady(false);
        }
    }, [executeRecaptcha]);

    const executeRecaptchaAction = useCallback(async (action) => {

        if (!executeRecaptcha) {
            console.warn('reCAPTCHA still loading');
            throw new Error('reCAPTCHA not ready');
        }

        try {
            const token = await executeRecaptcha(action);
            console.log('reCAPTCHA token generated successfully');
            return token;
        } catch (error) {
            console.error('reCAPTCHA execution failed:', error);
            throw new Error('reCAPTCHA verification failed');
        }
    }, [executeRecaptcha]);

    return {
        executeRecaptchaAction,
        isRecaptchaReady
    };
};